import dayjs from 'dayjs'
import { useFormContext } from 'react-hook-form'
import { BookAppointmentForm } from './BookAppointmentTypes'

const rows: Array<{ key: keyof BookAppointmentForm; label: string }> = [
  { key: 'facility', label: 'Facility' },
  { key: 'doctor', label: 'Doctor' },
  { key: 'appointmentType', label: 'Appointment Type' },
  { key: 'appointmentMode', label: 'Appointment Mode' },
  { key: 'reason', label: 'Reason for visit' },
  { key: 'date', label: 'Date' },
  { key: 'time', label: 'Time' }
]

export const BookAppointmentStepConfirm = () => {
  const { watch } = useFormContext<BookAppointmentForm>()
  const facilityName = watch('facilityName')
  const doctorName = watch('doctorName')
  const date = watch('date')
  const time = watch('time')
  const appointmentType = watch('appointmentType')
  const appointmentMode = watch('appointmentMode')
  const reason = watch('reason')
  const displayData = {
    facility: facilityName || '',
    doctor: doctorName || '',
    appointmentType: appointmentType,
    appointmentMode: appointmentMode,
    reason: reason,
    date: date ? dayjs(date).format('DD MMM, YYYY') : '',
    time: time ? `${time.startTime} – ${time.endTime}` : '—'
  }
  console.log(displayData)
  return (
    <div className="grid gap-6 pt-1">
      {rows.map(row => (
        <div className="grid grid-cols-[1fr_auto] items-start gap-3" key={row.key}>
          <p className="text-[28px] text-sm text-[#666666]">{row.label}</p>
          <p className="text-sm font-medium text-[#2A2A2A]">
            {String(displayData[row.key as keyof typeof displayData] || '—')}
          </p>
        </div>
      ))}
    </div>
  )
}
